// extracted by mini-css-extract-plugin
export default {"sideScrollContainer":"sidescroll_sideScrollContainer__9K7gQ","parallax":"sidescroll_parallax__zeOXf","scroller":"sidescroll_scroller__G0H0t"};